import { Button } from 'evergreen-ui'
import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { gql,useQuery } from '@apollo/client';
import { FieldBtn } from './SidebarWidget/SidebarWidget.style';
import Cookies from 'js-cookie';



export const FETCH_ALL_ESTATE = gql`
query Facilities {
  facilities {
    _id
    code
    name
    facilityManager
    totalProperties
    occupiedProperties
    availableProperties
    address
    country
    state
    city
    createdAt
    id
  }
}
`;

function AddAssetsPlaceholder() {
const history = useHistory()
const {  data }  = useQuery(FETCH_ALL_ESTATE);
const facilityId = Cookies.get('facilityId');

  return (
    <div>
      { facilityId === undefined &&
        <div className='center'
            style={{
                // width:"320px",
                padding:"16px",
                // border:"1px solid #eee",
                borderRadius:"4px",
                margin:"0px auto !important"
            }}
        >
        {/* {data.facilities} */}
        {data && data.facilities.length >0
          ?<h5>Pick an estate to continue</h5>
          :<p className='center'>Pls add an asset to continue</p>
        }
        
        {/* <center className='mt-50'>
            {loading && <Spinner />}
        </center> */}
        <div className=''>
            
            {data && <div>{
                  (data.facilities.length > 0) 
                    ?<FieldBtn onClick={()=>history.push('/listEstates')} class="waves-effect waves-light btn-flat ">
                        Pick an estate 
                      </FieldBtn> 
                    :<Button onClick={()=>history.push('/addAssets')}>
                      Add assets
                    </Button>
                }
              </div>
            }
        </div>
            
        </div>
      }
    </div>
  )
}

export default AddAssetsPlaceholder